import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'

type Props = {
	isDisabled: boolean
}

export const Item = styled.div<Props>`
	padding: 2px 6px;
	cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
	color: ${helpers.color.input.menuOption};
	text-align: left;

	&:hover > div {
		background-color: ${({ isDisabled }) => (isDisabled ? helpers.color.input.menuOptionBackgroundHoverDisabled : helpers.color.input.menuOptionBackgroundHover)};
	}
`
